import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/service-breadcrumb.webp'
import heroImg from '../Images/service-hero.webp'
import { serviceIntro, services } from "../Data";
import CustomCta from "../Components/CustomCta";
import Industries from "../Components/Industries";
import SchemaMarkup from "../Components/SchemaMarkup";
import createBreadcrumbSchema from "../Schema/breadcrumbSchema";
import createServiceSchema from "../Schema/serviceSchema";

const Services=()=>{
    useEffect(() => {
            document.title =
              "Industrial Packaging Services | Gurukrupa Wood Pvt. Ltd.";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Professional container lashing, export packaging & industrial packaging services for secure cargo transportation."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://gurukrupawood.com/services");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Industrial Packaging Services | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Professional container lashing, export packaging & industrial packaging services for secure cargo transportation."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://gurukrupawood.com/services");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://gurukrupawood.com/service.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Industrial Packaging Services | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Professional container lashing, export packaging & industrial packaging services for secure cargo transportation."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://gurukrupawood.com/service.webp"
            );
          }
          }, []);

const breadcrumbSchema = createBreadcrumbSchema([
  {
    name: "Home",
    url: "https://gurukrupawood.com/"
  },
  {
    name: "Services",
    url: "https://gurukrupawood.com/services"
  },
]);

const serviceSchema = createServiceSchema({
  name: "Industrial Packaging Services",
  description:
    "Professional container lashing, export packaging and industrial packaging services for secure cargo transportation.",
  url: "https://gurukrupawood.com/services",

  services: services.map((item) => ({
    name: item.title,
    description: item.desc
  }))
});

    return(
        <>

        <SchemaMarkup data={breadcrumbSchema} />
        <SchemaMarkup data={serviceSchema} />

        <Breadcrumb
  pageName="Services"
  bgImage={bgImg}
/>

        {/**OUR SERVICES SECTION */}
       <section className="services-section container">

  {/* LEFT CONTENT */}
  <motion.div
    className="services-left"
    initial={{ opacity: 0, x: -70 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.25 }}
  >

    {/* SUBHEADING */}
    <motion.h3
      className="section-subheading"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      OUR SERVICES
    </motion.h3>

    {/* HEADING */}
    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 35 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.15,
        duration: 0.75,
      }}
      viewport={{ once: true }}
    >
      Complete Packaging Solutions & Support
    </motion.h2>

    {/* TEXT */}
    <motion.p
      className="section-text"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.3,
        duration: 0.8,
      }}
      viewport={{ once: true }}
    >
      Our end-to-end packaging services provide a seamless transition from the
      production line to the final destination, prioritizing product safety and
      structural integrity at every turn. By integrating advanced materials
      with precision engineering, we streamline handling efficiency and
      reinforce security for both domestic and complex export operations.
      Whether navigating rugged transit routes or strict international shipping
      regulations, our solutions ensure your cargo arrives exactly as
      intended—protected, compliant, and ready for use.
    </motion.p>

    {/* SERVICES GRID */}
    <motion.div
      className="service-intro-grid"
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.14,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
    >

      {serviceIntro.map((item, i) => (
        <motion.div
          className="service-intro-card"
          key={i}
          variants={{
            hidden: {
              opacity: 0,
              y: 45,
              scale: 0.94,
            },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
            },
          }}
          transition={{
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1],
          }}
          whileHover={{
            y: -8,
          }}
        >

          {/* ICON */}
          <motion.div
            className="service-intro-icon-wrapper"
            whileHover={{
              rotate: 4,
              scale: 1.08,
            }}
            transition={{ duration: 0.3 }}
          >
            <motion.img
              src={item.icon}
              alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
              whileHover={{
                scale: 1.08,
              }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>

          {/* TITLE */}
          <motion.h4
            className="card-heading"
            whileHover={{
              letterSpacing: "0.3px",
            }}
          >
            {item.title}
          </motion.h4>

        </motion.div>
      ))}

    </motion.div>

  </motion.div>

  {/* RIGHT IMAGE */}
  <motion.div
    className="services-right"
    initial={{ opacity: 0, x: 70 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.25 }}
  >

    <motion.img
      src={heroImg}
      alt="Complete Packaging Solutions & Support | Gurukrupa Wood Pvt. Ltd."
      initial={{
        scale: 1.08,
        opacity: 0,
      }}
      whileInView={{
        scale: 1,
        opacity: 1,
      }}
      transition={{
        duration: 1,
      }}
      viewport={{ once: true }}
      whileHover={{
        scale: 1.03,
      }}
    />

  </motion.div>

</section>

        {/**SERVICES GRID */}
       <section className="services-grid-section">

  <div className="container">

    <motion.div
      className="services-grid"
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.16,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.12 }}
    >

      {services.map((item, i) => (
        <motion.div
          className="service-card"
          key={i}
          variants={{
            hidden: {
              opacity: 0,
              y: 65,
            },
            visible: {
              opacity: 1,
              y: 0,
            },
          }}
          transition={{
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1],
          }}
          whileHover={{
            y: -10,
          }}
        >

          {/* MAIN IMAGE */}
          <motion.div
            style={{
              overflow: "hidden",
            }}
          >
            <motion.img
              src={item.img}
              alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
              className="main-img"
              whileHover={{
                scale: 1.08,
              }}
              transition={{
                duration: 0.5,
              }}
            />
          </motion.div>

          {/* FLOATING ICON */}
          <motion.div
            className="service-icon"
            initial={{
              scale: 0,
              rotate: -10,
            }}
            whileInView={{
              scale: 1,
              rotate: 0,
            }}
            transition={{
              delay: 0.25 + i * 0.1,
              type: "spring",
              stiffness: 180,
              damping: 12,
            }}
            viewport={{ once: true }}
            whileHover={{
              rotate: 5,
              scale: 1.08,
            }}
          >
            <motion.img
              src={item.icon}
              alt={`${item.title} Icon | Gurukrupa Wood Pvt. Ltd.`}
              whileHover={{
                scale: 1.08,
              }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>

          {/* CONTENT */}
          <motion.div
            className="service-card-content"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              delay: 0.2,
              duration: 0.7,
            }}
            viewport={{ once: true }}
          >

            <motion.h4
              className="card-heading"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.3,
                duration: 0.5,
              }}
              viewport={{ once: true }}
            >
              {item.title}
            </motion.h4>

            <motion.p
              className="section-text"
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.4,
                duration: 0.6,
              }}
              viewport={{ once: true }}
            >
              {item.desc}
            </motion.p>

          </motion.div>

        </motion.div>
      ))}

    </motion.div>

  </div>

</section>

        {/**INDUSTRIES SECTION */}
        <Industries />
         <div className="industries-service-pg"></div>

        {/**CTA SECTION */}
        <CustomCta 
        heading="Need Custom Plywood Packaging Boxes?"
        desc="We provide tailor-made Plywood boxes to match your exact requirements. 
Get in touch with our team today!"
        />
        </>
    )
}
export default Services;